var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiploma11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V13C21 14.1046 20.1046 15 19 15H17.1251C17.3671 14.3801 17.5 13.7056 17.5 13C17.5 9.96243 15.0376 7.5 12 7.5C8.96243 7.5 6.5 9.96243 6.5 13C6.5 13.7056 6.63286 14.3801 6.87494 15H5C3.89543 15 3 14.1046 3 13V4ZM9 4.25C8.58579 4.25 8.25 4.58579 8.25 5C8.25 5.41421 8.58579 5.75 9 5.75H15C15.4142 5.75 15.75 5.41421 15.75 5C15.75 4.58579 15.4142 4.25 15 4.25H9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.944 15.4126C16.1042 17.1302 14.3957 18.3456 12.3908 18.4863L14.1856 21.6525C14.4664 22.1479 15.1819 22.1041 15.4025 21.5781L16.0049 20.1419C16.1239 19.8582 16.4124 19.6885 16.7131 19.7254L18.2355 19.9122C18.7931 19.9806 19.188 19.3714 18.9072 18.876L16.944 15.4126Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05602 15.4126C7.89578 17.1302 9.60426 18.3456 11.6092 18.4863L9.81439 21.6525C9.5336 22.1479 8.81807 22.1041 8.59746 21.5781L7.99512 20.1419C7.87613 19.8582 7.58759 19.6885 7.28687 19.7254L5.76449 19.9122C5.20692 19.9806 4.81197 19.3714 5.09276 18.876L7.05602 15.4126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma11);
export default __webpack_public_path__ + "static/media/diploma-1-1.ff0acd3fc2cc72fb630ca928ab412f4f.svg";
export { ForwardRef as ReactComponent };